import React from 'react';
import { Container, Paper, Text, Divider } from '@mantine/core';
import FileAnswerView from '../FileAnswerView';
export default function ResponseCard({ title, questionName, responseJson, type }) {

  const renderAnswer = (answer, key) => {
    if (answer == null) {
        return <Text color="dimmed">No response</Text>;
      }
    // NUMBER (rating, score, etc.)
      if (typeof answer === "number") {
        return <Text>{answer}</Text>;
      }
    if (typeof answer === "string") {
      // Base64 image (signature pad, etc.)
      if (answer.startsWith("data:image")) {
        return (
          <img
            key={key}
            src={answer}
            alt="signature"
            style={{
              maxWidth: 200,
              border: "1px solid #ccc",
              borderRadius: 6
            }}
          />
        );
      }

      // Normal text (comma / semicolon separated)
      return answer.split(/[;,]/).map((item, i) => (
        <Text key={`${key}-${i}`}>{item.trim()}</Text>
      ));
    }

    if (Array.isArray(answer)) {
    const isFileArray = answer.some(
      (item) => item && typeof item === "object" && (item.path || item.content || item.name || item.file?.name)
    );
    if (isFileArray) {
      return (
        <div key={key} style={{ marginBottom: 10 }}>
          <FileAnswerView value={answer} />
        </div>
      );
    }
    return answer.map((item, i) => renderAnswer(item, `${key}-${i}`));
  }
    
    if (typeof answer === "object" && answer !== null) {
    // ✅ Single file object
    if (answer.path || answer.content || answer.url || answer.name || answer.file) {
      return (
        <div key={key} style={{ marginBottom: 10 }}>
          <FileAnswerView value={answer} />
        </div>
      );
    }
  }

  return <Text key={key}>-</Text>;
};

const filteredJson = Array.isArray(responseJson)   // ← ADD HERE
  ? responseJson.filter((a) => !(Array.isArray(a) && a.length === 0))
  : [];

  return (
    <div>
      <Container>
        <Paper p={5} m={5} radius="sm" shadow="lg" style={{ border: '1.5px solid #bababa' }}>
          <Container fluid p={5} m={5}>
            <h2 style={{textTransform: 'capitalize'}}>{title}</h2>
          </Container>
          <Divider my="xs" size="sm" />
          <Container>
            {filteredJson.length > 0 ? (
              filteredJson.map((answerArray, index) => (
                <Paper
                  key={index}
                  p={15}
                  m={5}
                  shadow="xs"
                  radius="sm"
                  style={{ border: '1px solid #f0f0f0', marginBottom: '10px', backgroundColor: '#fafffaff' }}
                >
                  {(Array.isArray(answerArray) ? answerArray : [answerArray])
                    .filter((a) => a !== null && a !== undefined && a !== "")
                    .map((answer, idx) => renderAnswer(answer, idx))
                  }
                </Paper>
              ))
            ) : (
              <Text>No responses available</Text>
            )}
          </Container>
        </Paper>
      </Container>
    </div>
  );
}
